import { render } from "./LoaderImage.vue?vue&type=template&id=3ba61ed7&scoped=true"
import script from "./LoaderImage.vue?vue&type=script&lang=js"
export * from "./LoaderImage.vue?vue&type=script&lang=js"

import "./LoaderImage.vue?vue&type=style&index=0&id=3ba61ed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba61ed7"]])

export default __exports__